(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-group-orders"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('.nue-case').forEach(section => {
      const grid = section.querySelector('.nue-case__grid');
      const indicator = section.querySelector('.nue-case__pagination');
      if (!grid || !indicator || grid.dataset.paginationReady) return;
      grid.dataset.paginationReady = 'true';
      const cards = Array.from(grid.querySelectorAll('.nue-case__card'));
      let frame = 0;
      const update = () => {
        frame = 0;
        const start = grid.getBoundingClientRect().left + parseFloat(getComputedStyle(grid).scrollPaddingInlineStart || 0);
        let active = 0;
        let distance = Infinity;
        cards.forEach((card, index) => {
          const next = Math.abs(card.getBoundingClientRect().left - start);
          if (next < distance) {
            distance = next;
            active = index;
          }
        });
        const text = String(active + 1).padStart(2, '0') + ' / ' + String(cards.length).padStart(2, '0');
        if (indicator.textContent !== text) indicator.textContent = text;
        indicator.hidden = false;
      };
      const schedule = () => {
        if (!frame) frame = requestAnimationFrame(update);
      };
      grid.addEventListener('scroll', schedule, { passive: true });
      new ResizeObserver(schedule).observe(grid);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
